module.exports = __webpack_public_path__ + "img/1F1EE-1F1F2.e6d2c437.svg";